import { render, staticRenderFns } from "./MesClients.vue?vue&type=template&id=5149da1b"
import script from "./MesClients.vue?vue&type=script&lang=js"
export * from "./MesClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports